
<div class="container pt-3">
  <terms-and-conditions-text></terms-and-conditions-text>
</div>
